var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-viewer" },
    [
      _c("a", {
        staticClass: "view-full-screen",
        attrs: { href: "#" },
        on: {
          click: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.viewFullScreen.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _c("prism", { ref: "codebox", attrs: { language: "json" } }, [
        _vm._v(_vm._s(_vm.item.jsonStringDisplay))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a479f7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a479f7c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/data-viewer.vue
// module id = 1261
// module chunks = 0